import type {
  AlignItemsProperty,
  JustifyContentProperty,
} from '@mentimeter/ragnar-styled';
import type { TextAlignment } from '../types';

export const textVerticalAlignToJustifyContent: Record<
  TextAlignment['textVerticalAlign'],
  JustifyContentProperty
> = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
};

export const textHorizontalAlignToAlignItems: Record<
  TextAlignment['textHorizontalAlign'],
  AlignItemsProperty
> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};
